import React from "react";
import "./OnePage.css";
import Menu from "../Navigation/Menu";
import axios from "axios";

const OnePage = () => {
  const [slider, setSlider] = React.useState(0);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [messageSent, setMessageSent] = React.useState(false);
  const [messageError, setMessageError] = React.useState("");

  const sendContactMessage = async (e) => {
    e.preventDefault();
    const response = await axios.post(
      "https://ac-corse-recrutement.fr/api/contact",
      {
        name,
        email,
        phone,
      }
    );

    if (response.data.succeed) {
      setMessageSent(true);
    } else {
      setMessageError(
        "Une erreur est survenue lors de l'envoi du message. Veuillez réessayer."
      );
    }
  };

  return (
    <div className="OnePage">
      <Menu />
      <div className="OnePage-header">
        <div className="OnePage-header-content">
          <div className="OnePage-header-title">
            <div className="OnePage-header-title">
              <h2>
                Votre partenaire pour une saison réussie, au service de
                l'hôtellerie et de la restauration.
              </h2>
              <p>
                Notre agence vous accompagne dans la recherche de talents et de
                postes saisonniers, pour une saison réussie.
              </p>
            </div>
          </div>
          <div className="OnePage-action-button">Nous contacter</div>
          <div className="Scroll-down-icon">
            <i class="fa fa-arrow-down" aria-hidden="true"></i>
          </div>
        </div>
        <div className="OnePage-header-pictures">
          <div className="OnePage-header-picture-1"></div>
          <div className="OnePage-header-picture-2"></div>
          <div className="OnePage-header-picture-3"></div>
        </div>
      </div>
      <div className="OnePage-presentation" id="about">
        <div className="OnePage-presentation-big-text">
          <div className="OnePage-presentation-big-text-content">
            <h3>Notre Agence</h3>
            <p>
              Notre agence se concentre sur la création de liens solides entre
              les saisonniers et les employeurs. Nous sommes là pour faciliter
              votre recherche d'emploi, en vous offrant un accompagnemen
              personnalisé et des conseils pratiques adaptés à votre parcours.
              Que vous soyez un jeune talent ou un professionnel expérimenté,
              nous avons à cœur de vous orienter vers des opportunités qui
              correspondent à vos aspirations et à vos compétences.
            </p>
          </div>
          <div className="OnePage-presentation-big-text-picture"></div>
        </div>
        <div className="OnePage-presentation-small-texts">
          <div className="OnePage-presentation-small-text">
            <h4>Nos Valeurs</h4>
            <p>
              Nous croyons fermement en des valeurs humaines et d'entraide.
              Chaque candidat est unique, et nous nous engageons à écouter vos
              besoins et à vous guider à chaque étape de votre parcours. Notre
              réseau solide de restaurateurs et d'hôteliers dans la région nous
              permet de vous connecter avec des employeurs sérieux, soucieux de
              valoriser vos talents. Ensemble, faisons de votre saison une
              réussite !
            </p>
          </div>
          <div className="OnePage-presentation-small-text">
            <h4>Expérience</h4>
            <p>
              Forte de plus de 10 ans d'expérience dans le secteur de
              l'hôtellerie et de la restauration, notre fondatrice Axelle
              Chauvet met à votre service son expertise et son savoir-faire.
              Elle a travaillé dans presque tous les services de ce secteur
              passionnant, ce qui lui permet de comprendre les défis et les
              exigences de chaque rôle. Son objectif est de vous aider à trouver
              la position qui vous correspond le mieux, en vous offrant un
              accompagnement personnalisé et des conseils pratiques.
            </p>
          </div>
        </div>
      </div>
      <div className="OnePage-services" id="services">
        <div className="OnePage-service-slider">
          <div
            className={
              slider === 0
                ? "OnePage-service-employeur-active"
                : "OnePage-service-employeur"
            }
            onClick={() => setSlider(0)}
          >
            <div className="OnePage-service-employeur-picture"></div>
            <div className="OnePage-service-employeur-text-zone">
              <h2>Vous êtes employeur ?</h2>
              <p
                className={
                  slider === 0
                    ? "OnePage-service-employeur-text"
                    : "OnePage-service-employeur-text-hidden"
                }
              >
                Si vous préparez votre prochaine saison et que vous cherchez des
                talents pour compléter votre équipe, nous sommes là pour vous
                aider. Notre agence vous propose un service de recrutement
                personnalisé, pour vous mettre en relation avec des candidats
                motivés et qualifiés. Nous vous accompagnons dans la recherche
                de professionnels compétents, pour des postes en cuisine, en
                salle, à la réception ou en hébergement. Contactez-nous pour en
                savoir plus sur nos services.
              </p>
              <div
                className={
                  slider === 0
                    ? "OnePage-service-employeur-button-active"
                    : "OnePage-service-employeur-button"
                }
              >
                Nous contacter
              </div>
            </div>
          </div>
          <div
            className={
              slider === 1
                ? "OnePage-service-employeur-active"
                : "OnePage-service-employeur"
            }
            onClick={() => setSlider(1)}
          >
            <div className="OnePage-service-employe-picture"></div>
            <div className="OnePage-service-employeur-text-zone">
              <h2>Vous cherchez un emploi ?</h2>
              <p
                className={
                  slider === 1
                    ? "OnePage-service-employeur-text"
                    : "OnePage-service-employeur-text-hidden"
                }
              >
                Vous êtes à la recherche d'un emploi saisonnier dans le secteur
                de l'hôtellerie et de la restauration ? Notre agence vous
                propose un accompagnement personnalisé pour vous aider à trouver
                la position qui vous correspond. Notre réseau de restaurateurs
                et d'hôteliers nous permet de vous mettre en relation avec des
                employeurs sérieux, qui valoriseront vos compétences et votre
                expérience. Contactez-nous pour en savoir plus sur nos offres
                d'emploi.
              </p>
              <div
                className={
                  slider === 1
                    ? "OnePage-service-employeur-button-active"
                    : "OnePage-service-employeur-button"
                }
              >
                Nous contacter
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="OnePage-our-team">
        <div className="OnePage-our-team-zone">
          <div className="OnePage-our-team-text">
            <div className="OnePage-our-team-title">
              <h2>Qui sommes-nous ?</h2>
            </div>
            <div className="OnePage-our-team-content">
              <div className="OnePage-our-team-description">
                <p className="OnePage-our-team-description-text">
                  Je suis Axelle Chauvet, fondatrice de cette agence dédiée à
                  l'accompagnement des saisonniers dans le secteur de
                  l'hôtellerie et de la restauration. Avec plus de 10 ans
                  d'expérience, j'ai eu l'opportunité de travailler dans presque
                  tous les services de ce secteur passionnant. Mon parcours m'a
                  permis de comprendre les défis et les exigences de chaque
                  rôle, que ce soit e cuisine, en salle ou à la réception. C'est
                  cette expertise que je mets à votre service pour vous aider à
                  trouver la position qui vous correspond le mieux.
                </p>
              </div>
              <div className="OnePage-our-team-picture"></div>

            </div>
          </div>
        </div>
      </div>
      <div className="OnePage-quick-contact" id="contact">
        <div className="OnePage-quick-contact-content">
          <div className="OnePage-quick-contact-form-zone">
            <div className="OnePage-quick-contact-form">
              <h2>Être contacté</h2>
              <p className="OnePage-quick-contact-text">
                N'hésitez pas à me contacter ou à remplir se formulaire pour
                toute question ou pour discuter de vos projets professionnels.
                Je suis là pour vous accompagner dans cette belle aventure et
                vous aider à réaliser vos ambitions
              </p>
              {!messageSent ? (
                <form>
                  <input
                    type="text"
                    placeholder="Nom (ou Entreprise)"
                    onChange={(e) => setName(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Téléphone"
                    onChange={(e) => setPhone(e.target.value)}
                  />
                  <button
                    className="OnePage-quick-contact-button"
                    onClick={sendContactMessage}
                  >
                    Envoyer
                  </button>
                </form>
              ) : (
                <div className="OnePage-quick-contact-message-sent">
                  <p>
                    Votre message a bien été envoyé. Nous vous répondrons dans
                    les plus brefs délais.
                  </p>
                </div>
              )}
            </div>
            <div className="OnePage-quick-contact-image"></div>
          </div>
          <div className="OnePage-quick-contact-mentions">
            <div
              className="OnePage-quick-contact-mentions-phone"
              onClick={() => window.open("tel:0686859208")}
            >
              <i class="fa fa-phone" aria-hidden="true"></i>
              <p>06 86 85 92 08</p>
            </div>
            <div
              className="OnePage-quick-contact-mentions-email"
              onClick={() =>
                window.open("mailto:contact@ac-corse-recrutement.fr")
              }
            >
              <i class="fa fa-envelope" aria-hidden="true"></i>
              <p>contact@ac-corse-recrutement.fr</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnePage;
